import { Component, Input, Inject } from '@angular/core';
import { SideEffect } from '../../../../../common/models/flow.dto';
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from '../models/types';


@Component({
    selector: 'side-effect-generate-uncounted-identifiers',
    templateUrl: './side-effect-generate-uncounted-identifiers.component.html',
    standalone: false
})
export class SideEffectGenerateUncountedIdentifiersComponent {  
    public _sideEffect: SideEffect;

    set sideEffect(value: SideEffect) {
        this._sideEffect = value;

        if (!this.sideEffect.configuration)
            this._sideEffect.configuration = { ContextTargets: [] };

        this._fixConfig(this._sideEffect.configuration);
    }

    get sideEffect(): SideEffect {
        return this._sideEffect;
    }

    constructor(
        @Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData
    ) {
        this.sideEffect = data.sideEffect;
    }

    public _fixConfig(seconf: any): void {
        if (!seconf.ContextTargets)
            seconf.ContextTargets = [];
    }

    addRule(): void {
        this.sideEffect.configuration.ContextTargets.push({
            contextTarget: "",
            condition: "true"
        });
    }

    removeRule(index: number): void {
        this.sideEffect.configuration.ContextTargets.splice(index, 1);
    }

    swapRules(i: number, j: number) {
        var left = this.sideEffect.configuration.ContextTargets[i];
        var right = this.sideEffect.configuration.ContextTargets[j];
        this.sideEffect.configuration.ContextTargets[i] = right;
        this.sideEffect.configuration.ContextTargets[j] = left;
    }
}

